/**
 * True when the page is driven by a browser-automation tool (Playwright,
 * Cypress launched with a Chrome family browser, Selenium, etc.). All
 * compliant automation drivers set the W3C-spec `navigator.webdriver` flag.
 *
 * Branch on this to skip behaviours that don't belong in a test run:
 * refresh-token logic, Honeybadger, Braze, activity tracking, MUI auto-resize.
 *
 * https://playwright.dev/docs/api/class-page tells you `navigator.webdriver`
 * is `true` for every Playwright-controlled page.
 */
export function isTestRunning(): boolean {
  return typeof navigator !== "undefined" && Boolean(navigator.webdriver);
}
